module.exports = __webpack_public_path__ + "img/Iraq.33287b22.png";